import Vue from "vue";
import App from "./App";
import router from "./router/index";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import store from './store';
import VueNativeNotification from 'vue-native-notification';
import VueMask from 'v-mask'
Vue.use(VueMask);

Vue.use(PaperDashboard);

Vue.component('fields-list', () => import("@/components/Card/FieldsList"));
Vue.component('list', () => import("@/components/List"));

Vue.component('search-image', () => import("@/components/SearchImage"));
Vue.component('tags', () => import("@/components/Tags"));

let items = store.state.items;
Object.keys(items).forEach(key => {
  Vue.component(key, () => import(`@/components/Card/${items[key]}/index`));
});


try {
  Notification.requestPermission()
    .then(() => {
    });
  Vue.use(VueNativeNotification, {
    requestOnNotify: true
  });
} catch (error) {

}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
